import { useCallback } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { c as getQueryParam, m as mergeQueryParam, s as stripQueryParam } from "./utils-CztPRCN_.js";
function useUrlQueryParam(paramKey, defaultValue = "") {
  const { search } = useLocation();
  const history = useHistory();
  const rawQueryParam = getQueryParam(search, paramKey);
  const setQueryParam = useCallback(
    (value) => {
      const newSearch = mergeQueryParam(search, paramKey, value);
      history.replace({ search: newSearch });
    },
    [search, paramKey, history]
  );
  const removeQueryParam = useCallback(() => {
    const newSearch = stripQueryParam(search, paramKey);
    history.replace({ search: newSearch });
  }, [search, paramKey, history]);
  const queryParam = rawQueryParam || defaultValue;
  return { queryParam, setQueryParam, removeQueryParam };
}
export {
  useUrlQueryParam as u
};
//# sourceMappingURL=useUrlQueryParam-CjUhdvgb.js.map
